const NUMBER_FORMATTER = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1 });

/** 1_250_000 → "1,2 MB" */
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${NUMBER_FORMATTER.format(bytes / 1024)} KB`;
  return `${NUMBER_FORMATTER.format(bytes / (1024 * 1024))} MB`;
};
